import type { DataForCreateKubernetes } from '@/entities/kubernetes';
import request from '@/shared/api/request';

export const getDataForCreateKubernetes = (): Promise<DataForCreateKubernetes> =>
  request({
    url: '/kubernetes/data_for_create/',
  });
